import React, { useState } from 'react';
import { useCreate, useNotify, useRefresh, useTranslate } from 'react-admin';
import { useParams } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { convertFileToBase64 } from '../../../../core/utils/file-utils';
import { FileDropzone } from '../../../../components/shared/FileDropzone';
import { EXCEL_ACCEPT } from '../../../../core/constants/file.constants';

export const PumpsSpeedImport = () => {
  const [file, setFile] = useState<File | null>(null);
  const [create, { isLoading }] = useCreate();
  const notify = useNotify();
  const refresh = useRefresh();
  const params = useParams();
  const t = useTranslate();

  const handleSubmit = async () => {
    if (!file) return;
    const base64 = await convertFileToBase64(file);
    create(
      'pumps/import-pump-speed',
      { data: { pumpHash: params?.pumpId, file: base64 } },
      {
        onSuccess: () => {
          notify('resources.pumps.speeds.notifications.create.success', {
            type: 'success'
          });
          setFile(null);
          refresh();
        },
        onError: (error: any) => {
          notify(error.message, { type: 'warning' });
        }
      }
    );
  };

  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 2 }}>
      <FileDropzone accept={EXCEL_ACCEPT} file={file} onFileChange={setFile} />

      {file && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {t('resources.pumps.speeds.fields.import')}
          </Button>
        </Box>
      )}
    </Box>
  );
};
